import React, { useRef, useEffect, useState } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css'; // Estilos predefinidos de Quill

const BlogEditor = () => {
    const editorRef = useRef(null);
    const quillRef = useRef(null); // Ref para almacenar la instancia de Quill
    const [content, setContent] = useState('');

    useEffect(() => {
        console.log('useEffect called');
        if (editorRef.current && !quillRef.current) {
            console.log('Initializing Quill editor');
            quillRef.current = new Quill(editorRef.current, {
                theme: 'snow' // Configura el tema del editor (puedes personalizarlo)
            });

            quillRef.current.on('text-change', () => {
                setContent(quillRef.current.root.innerHTML);
            });
        } else {
            console.log('Quill editor already initialized');
        }

        return () => {
            if (quillRef.current) {
                console.log('Cleaning up Quill editor');
                quillRef.current.off('text-change');
                quillRef.current = null; // Limpiar la referencia cuando el componente se desmonte
            }
        };
    }, []);

    const handleSave = () => {
        // Aquí puedes enviar 'content' al servidor para guardarlo en tu base de datos
        console.log('Contenido guardado:', content);
        // Aquí puedes agregar la lógica para enviar 'content' al servidor y manejar la respuesta
    };

    return (
        <div>
            <div ref={editorRef} id="editor" />
            <button onClick={handleSave}>Guardar</button>
        </div>
    );
};

export default BlogEditor;
